import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from './Header';

function InferencesTable() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="inferences-table-page">
            {/* <Header /> */}
            <div className="inferences-container">
                <div className="inferences-header">
                    <Link to="/private" className="back-button">
                        <span className="back-arrow">←</span> Back to Overview
                    </Link>
                    <h1 className="inferences-title">Research-Backed Operational Fitness Areas</h1>
                    <p className="inferences-subtitle">
                        Our assessment focuses on these key areas that research shows significantly impact workplace compatibility and success.
                    </p>
                </div>
                
                <div className="inferences-table-wrapper">
                    <table className="inferences-table">
                        <thead>
                            <tr>
                                <th>What we're testing</th>
                                <th>Why this is important</th>
                                <th>References</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Flexibility & Work Arrangements</strong><br />
                                    The importance of flexible work schedules and environments e.g. flexible hours, remote work options, and the ability to manage personal responsibilities alongside professional duties.
                                </td>
                                <td>
                                    <ul>
                                        <li>Employees with flexible work schedules report higher perceived productivity and organizational commitment, leading to lower turnover.</li>
                                        <li>Greater autonomy in work arrangements improves work quality and employee motivation, enhancing overall engagement.</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul className="reference-list">
                                        <li>Hashmi, M. A., Al Ghaithi, A., & Sartawi, K. (2023).</li>
                                        <li>Hunter (2019).</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Social Preferences</strong><br />
                                    How individuals prefer to interact within the workplace, including their inclination toward teamwork, socializing with colleagues, and overall integration into the company culture.
                                </td>
                                <td>
                                    <ul>
                                        <li>Effective collaboration and shared social practices contribute to a stronger organizational culture, fostering improved performance and employee satisfaction.</li>
                                        <li>Companies with a cohesive social environment experience higher levels of employee retention and engagement, as workers feel more aligned with the company's values and culture.</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul className="reference-list">
                                        <li>Morales-Huñán et al. (2023).</li>
                                        <li>Adham, T. K. I., & Sukkar, A. (2024).</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Workplace Values & Environment</strong><br />
                                    The principles and atmosphere that define a workplace, including formal policies like dress codes, the level of managerial support for employee well-being, and the availability of mental health resources.
                                </td>
                                <td>
                                    <ul>
                                        <li>A positive workplace environment significantly enhances employee commitment and achievement-striving ability, leading to improved task performance.</li>
                                        <li>Providing a conducive work environment is important to foster employee well-being and organizational commitment.</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul className="reference-list">
                                        <li>Zhenjing, G., Chupradit, S., Ku, K. Y., Nassani, A. A., & Haffar, M. (2022).</li>
                                        <li>Raziq, A., & Maulabakhsh, R. (2015).</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Work Style & Independence</strong><br />
                                    Explores individual approaches to work, including preferences for structured versus unstructured tasks, the degree of autonomy desired, and adaptability to varying work conditions.
                                </td>
                                <td>
                                    <ul>
                                        <li>Workspace flexibility and functional flexibility have significant positive relationships with employee engagement, suggesting that allowing employees to tailor their work environment and schedule enhances their commitment and performance.</li>
                                        <li>It underscores the importance of providing employees with the freedom to choose their work styles to boost engagement and productivity.</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul className="reference-list">
                                        <li>Tingo, J., & Mseti, S. (2022).</li>
                                        <li>Lee, S. H., Chong, C. W., & Ojo, A. O. (2024).</li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Career Growth & Expectations</strong><br />
                                    Addresses an individual's aspirations regarding professional development, advancement opportunities, and expectations for organisational support in achieving career goals.
                                </td>
                                <td>
                                    <ul>
                                        <li>It is important to align individual career goals with organisational objectives.</li>
                                        <li>Organisations should provide clear career development pathways to meet employee expectations and enhance job satisfaction.</li>
                                        <li>Clear performance expectations can enhance motivation and performance; unrealistic expectations may lead to stress and decreased well-being.</li>
                                        <li>Managing employee expectations to balance motivation with well-being is important.</li>
                                    </ul>
                                </td>
                                <td>
                                    <ul className="reference-list">
                                        <li>Weng, Q., & Zhu, Y. (2020).</li>
                                        <li>Smollan, R. K., & Mooney, S. K. (2024).</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="inferences-footer">
                    <Link to="/private" className="primary-button">
                        Return to Overview
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default InferencesTable; 